import {Component, Input} from '@angular/core';
import {PaymentProviderResponse, PaymentReceipt} from '@gatewee/types/payment';
import {
  BankSlipValidateResponse,
  WithdrawalReceiverPaymentInfo,
} from '@gatewee/types/withdrawal';

@Component({
  selector: 'app-bank-slip-step-proof',
  templateUrl: './bank-slip-step-proof.component.html',
  standalone: false,
})
export class BankSlipStepProofComponent {
  @Input() validated: BankSlipValidateResponse | null = null;
  @Input() receiverPaymentInfo: WithdrawalReceiverPaymentInfo | null = null;
  @Input() isWithdrawalPolling = false;
  @Input() isWithdrawalSuccess = false;
  @Input() isWithdrawalFailed = false;
  @Input() statusErrorMessage: string | null = null;
  @Input() paymentReceipt?: PaymentReceipt;
  @Input() paymentMetadata?: PaymentProviderResponse<unknown, unknown>;
  @Input() amount: number | null = null;
  @Input() calculatedFee: number | null = null;
  @Input() finalAmount: number | null = null;

  get beneficiaryName(): string {
    const fromReceipt = String(
      this.paymentReceipt?.receiver?.holderName ?? '',
    ).trim();
    if (fromReceipt) {
      return fromReceipt;
    }
    const fromValidated =
      this.validated?.finalBeneficiary?.name ||
      this.validated?.issuingEntity?.name ||
      '';
    if (fromValidated) {
      return fromValidated;
    }
    const info = this.receiverPaymentInfo;
    return String(info?.holderName ?? info?.name ?? '').trim();
  }

  get beneficiaryDocument(): string {
    const fromReceipt = String(
      this.paymentReceipt?.receiver?.holderDocument ?? '',
    ).trim();
    if (fromReceipt) {
      return fromReceipt;
    }
    const fromValidated = String(
      this.validated?.finalBeneficiary?.taxID ?? '',
    ).trim();
    if (fromValidated) {
      return fromValidated;
    }
    const info = this.receiverPaymentInfo;
    return String(info?.holderDocument ?? info?.document ?? '').trim();
  }

  get digitableLine(): string {
    const fromReceipt = String(this.paymentReceipt?.digitableLine ?? '').trim();
    if (fromReceipt) {
      return fromReceipt;
    }
    const fromValidated = String(this.validated?.digitableLine ?? '').trim();
    if (fromValidated) {
      return fromValidated;
    }
    return String(this.receiverPaymentInfo?.digitableLine ?? '').trim();
  }
}
